import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appTableCellHost]',
  standalone: false,
})
export class TableCellAnchorDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
